import angular from 'angular';
import moment from 'moment';
import _ from 'lodash';

// eslint-disable-next-line angular/window-service
const { host, protocol } = window.location;
const PREFIX = `${protocol}//${host.substr(0, host.indexOf('-') + 1)}`;
let DOMAIN = `${host.substr(host.indexOf('.') + 1)}`;

const IS_DEV = DOMAIN.includes(':');
DOMAIN = IS_DEV ? 'shoppre.test' : DOMAIN;
const domianSplit = DOMAIN.split('.')[1];

const mainDomianSplit = DOMAIN.split('.')[0];
const LOGIN_PARCELS_DOMAIN = IS_DEV ? 'shoppre.test' : `${mainDomianSplit}.${domianSplit}`;

const GSUITE_DOMAIN = {
  'cureskin.com': 'heallo.ai',
}[DOMAIN] || 'shoppre.com';

const LOGIN_APP = IS_DEV ? 'http://localhost:5001' : `${PREFIX}login.${DOMAIN}`;
const CAMPAIGN = `${PREFIX}campaign.${DOMAIN}`;
const REFERRAL = `${PREFIX}referral.${DOMAIN}`;
const WWW = `${PREFIX}www.${DOMAIN}`;

const constants = angular
  .module('accountsApp.constants', [])
  .constant('moment', moment)
  .constant('urls', {
    PREFIX,
    DOMAIN,
    LOGIN_APP,
    WWW,
    GSUITE_DOMAIN,
    LOGIN_PARCELS_DOMAIN,
    CAMPAIGN,
    REFERRAL,
  })
  .constant('CAPTCHA_SITE', {
    KEY: '6LfzxcwUAAAAAG4T4KzPdgMPv7Ovfax1aR6HsIww',
  })
  .constant('SETTINGS', {
    SITE_URL: `${PREFIX}${DOMAIN}`,
    SITE_NAME: _.capitalize(DOMAIN.split('.')[0]),
    LOGO_URL: './assets/images/logo.png',
    SUPPORT_EMAIL: `suppport@${DOMAIN}`,
    ADDRESS_LINE1: 'Bangalore',
    ADDRESS_LINE2: 'Bangalore',
    PHONE: 'NA',
  });

export default constants.name;



// WEBPACK FOOTER //
// ./client/app/app.constant.js